var map = {
	"./Bath/Header": [
		43609,
		4992
	],
	"./CQU/Header": [
		1916,
		3516
	],
	"./Deakin/Header": [
		37839,
		8955
	],
	"./JCU/Header": [
		937,
		2999
	],
	"./Melbourne/Header": [
		51698,
		6692
	],
	"./Monash/Header": [
		11805,
		3193
	],
	"./Nanyang/Header": [
		81791,
		6285
	],
	"./QUT/Header": [
		80517,
		9319
	],
	"./Sydney/Header": [
		84539,
		6947
	],
	"./UWA/Header": [
		1216,
		6276
	],
	"./UniSA/Header": [
		79477,
		6151
	],
	"./angliss/Header": [
		23210,
		8990
	],
	"./glos/Header": [
		65482,
		4848
	],
	"./local/Header": [
		38336,
		1176
	],
	"./staging/Header": [
		52278,
		9794
	],
	"./staging5v11/Header": [
		50791,
		7373
	],
	"./staging5v12/Header": [
		53490,
		6374
	],
	"./staging5v13/Header": [
		71157,
		767
	],
	"./staging5v14/Header": [
		74216,
		1744
	],
	"./staging5v15/Header": [
		96875,
		4553
	],
	"./staging5v16/Header": [
		30246,
		7362
	],
	"./staging5v16codefreeze/Header": [
		77440,
		468
	],
	"./staging5v16regression/Header": [
		96695,
		3765
	],
	"./stagingQUT/Header": [
		96017,
		4900
	],
	"./strath/Header": [
		20409,
		6853
	],
	"./uk/Header": [
		46887,
		3251
	],
	"./unihubuk/Header": [
		19987,
		6484
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 25641;
module.exports = webpackAsyncContext;